import { STORY_FIELDS } from "../isomorphic/constants";

export const getSearchPageItems = async (slug, offset, limit, publishedAfter, publishedBefore, sortBy, sectionIds) => {
  const params = new URLSearchParams();
  params.append('q', slug);
  params.append('offset', offset);
  params.append('limit', limit + 1);
  
  if (publishedAfter) {
    params.append('published-after', publishedAfter);
  }
  if (publishedBefore) {
    params.append('published-before', publishedBefore);
  }
  if (sortBy) {
    params.append('sort', sortBy);
  }
  if (sectionIds && sectionIds.length > 0) {
    params.append('section-id', sectionIds.join(','));
  }

  params.append('fields', STORY_FIELDS);
  
  const { results } = await (await fetch(`/api/v1/search?${params.toString()}`)).json();
  const loadMoreStories = results.stories.map((story) => {
    return { type: "story", story: story };
  });
  return loadMoreStories;
};

export const getStories = async (query, slug, offset, limit) => {
  const { stories } = await (
    await fetch(`/api/v1/stories?${query}=${slug}&offset=${offset}&limit=${limit + 1}`)
  ).json();
  const loadMoreStories = stories.map((story) => {
    return { type: "story", story: story };
  });
  return loadMoreStories;
};

export const getCollectionitems = async (slug, offset, limit) => {
  const { items } = await (
    await fetch(`/api/v1/collections/${slug}?&item-type=story&offset=${offset}&limit=${limit + 1}`)
  ).json();
  return items;
};

export const getAuthorStories = async (id, offset, limit) => {
  const { items } = await (
    await fetch(`/api/v1/authors/${id}/collection?&item-type=story&offset=${offset}&limit=${limit}`)
  ).json();
  return items;
};

export const loadRelatedStories = async (story, config) => {
  const { mountAt } = config || {};
  const mountAtPrefix = mountAt || "";
  const sectionQuery = story.sections && story.sections.length !== 0 ? `section-id=${story.sections[0].id}` : "";
  const response = await global
    .wretch(`${mountAtPrefix}/api/v1/stories/${story.id}/related-stories?${sectionQuery}`)
    .query({
      fields: STORY_FIELDS,
    })
    .get()
    .json((relatedStories) => relatedStories["related-stories"]);
  return response;
};

export const getEntityData = async (slug) => {
  const data = await (await fetch(`/api/v1/entity/${slug}`)).json();
  return data;
};

// Generate JWT token for metype integration
export async function generateJwtToken(metypeConfig) {
  try {
    const response = await fetch(`/api/v1/access-token/integrations/${metypeConfig.integrationsId}`);
    if (!response.ok) {
      throw new Error(`Error fetching JWT: ${response.status}`);
    }
    const result = response.headers.get("x-integration-token");
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
}

// Convert URL to base64 for metype page ID
function urlToBase64(url) {
  if (typeof window !== "undefined" && window.btoa) {
    return window.btoa(url);
  }
  // Fallback for server-side
  return Buffer.from(url).toString("base64");
}

// Create bookmark for read later functionality
export function createBookmark(metypeConfig, storyUrl, data, token) {
  const pageId = urlToBase64(storyUrl);
  const url = `${metypeConfig.metypeHost}/api/v1/accounts/${metypeConfig.metypeAccountId}/pages/${pageId}/bookmark?jwt=${token}`;

  return fetch(url, {
    method: "POST",
    headers: {
      "Referer": "",
      "Content-Type": "application/json",
      "Origin": metypeConfig.metypeHost
    },
    body: JSON.stringify(data)
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Bookmark failed: ${response.status}`);
      }
      return response.json();
    })
    .catch((error) => {
      console.error("Error creating bookmark:", error);
      throw error;
    });
}

// Get bookmark by page ID
export function getBookmarkByPageId(metypeConfig, storyUrl, token) {
  const base64Url = urlToBase64(storyUrl);
  const url = `${metypeConfig.metypeHost}/api/v1/accounts/${metypeConfig.metypeAccountId}/pages/${base64Url}/bookmark?jwt=${token}`;

  return fetch(url, {
    method: "GET",
    headers: {
      "Referer": "",
      "Content-Type": "application/json",
      "Origin": metypeConfig.metypeHost
    }
  })
    .then((response) => {
      if (!response.ok) {
        if (response.status === 404) {
          return null; // Not bookmarked
        }
        throw new Error(`Get bookmark failed: ${response.status}`);
      }
      return response.json();
    })
    .then((result) => result?.data || null)
    .catch((error) => {
      console.error("Error getting bookmark:", error);
      return null;
    });
}

// Delete bookmark by page ID
export function deleteBookmarkByPageId(metypeConfig, storyUrl, token) {
  console.log(storyUrl)
  const base64Url = urlToBase64(storyUrl);
  const url = `${metypeConfig.metypeHost}/api/v1/accounts/${metypeConfig.metypeAccountId}/pages/${base64Url}/bookmark?jwt=${token}`;

  return fetch(url, {
    method: "DELETE",
    headers: {
      "Referer": "",
      "Content-Type": "application/json",
      "Origin": metypeConfig.metypeHost
    }
  })
    .then((response) => {
      if (!response.ok && response.status !== 204) {
        throw new Error(`Delete bookmark failed: ${response.status}`);
      }
      return Promise.resolve();
    })
    .catch((error) => {
      console.error("Error deleting bookmark:", error);
      throw error;
    });
}

// Get all bookmarks for a user
export function getAllBookmarks(metypeConfig, token) {
  const url = `${metypeConfig.metypeHost}/api/v1/accounts/${metypeConfig.metypeAccountId}/bookmarks?jwt=${token}`;

  return fetch(url, {
    method: "GET",
    headers: {
      "Referer": "",
      "Content-Type": "application/json",
      "Origin": metypeConfig.metypeHost
    }
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Get bookmarks failed: ${response.status}`);
      }
      return response.json();
    })
    .then((result) => {
      return {
        data: result?.data || [],
        total_count: result?.total_count || 0
      };
    })
    .catch((error) => {
      console.error("Error getting bookmarks:", error);
      return { data: [], total_count: 0 };
    });
}